import {
  GET_PLANS,
  CREATE_PLANS,
  DELETE_PLANS,
  UPDATE_PLANS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  plans: null,
  error: {},
  success: "",
};

const Plans = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PLANS:
          return {
            ...state,
            plans: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_PLANS:
          return {
            ...state,
            success: "Sucessfully created plans",
            error: {},
          };
        case UPDATE_PLANS:
          return {
            ...state,
            success: "Sucessfully updated plans",
            error: {},
          };
        case DELETE_PLANS:
          return {
            ...state,
            success: "Sucessfully delete plans",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_PLANS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_PLANS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_PLANS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_PLANS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_PLANS: {
      return {
        ...state,
      };
    }
    case CREATE_PLANS: {
      return {
        ...state,
      };
    }
    case UPDATE_PLANS: {
      return {
        ...state,
      };
    }
    case DELETE_PLANS: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Plans;
